import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as Yup from 'yup';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Box, Divider, Typography } from '@mui/material';
import { Form, Formik } from 'formik';

import useNotification from '../../../../../../core/hooks/use_notification';
import { getAllPodsState } from '../../../../../../features/pod/get_all_pods';
import { Button, SubmitButton } from '../../../../../common/button';
import { SelectFieldMultipleFormikWithMore } from '../../../../../common/select_field';
import { deleteProductPromotionsNotificationData } from '../../../../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';
import { deleteProductPromotionsAction, deleteProductPromotionsState } from '../../../../../../features/price/delete_product_promotions';

const DeletePromotionsFormDialog = ({ productId, refreshList }) => {
    const { showNotification } = useNotification();
    const dispatch = useDispatch();

    const getAllPods = useSelector(getAllPodsState);
    const deleteProductPromotions = useSelector(deleteProductPromotionsState);

    const [open, setOpen] = useState(false);

    const initialValues = {
        podIds: [],
    };

    const schema = Yup.object().shape({
        podIds: Yup.array().min(1, 'Proszę wybrać co najmniej jeden punkt')
    }, ['podIds']);

    const onClose = () => setOpen(false);

    const onSubmit = (values) => {
        dispatch(deleteProductPromotionsAction({ productId, form: values }))
            .then(response => {
                showNotification(deleteProductPromotionsNotificationData(response));
                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    refreshList && refreshList();
                    onClose();
                }
            });
    };

    return (
        <>
            <Button color="error" variant="outlined" onClick={ () => setOpen(true) }>
                Usuń promocje masowo
            </Button>

            <Dialog open={ open } onClose={ onClose } fullWidth={ true } maxWidth="md">
                <Formik
                    initialValues={ initialValues }
                    validationSchema={ schema }
                    validateOnChange
                    validateOnBlur={ false }
                    onSubmit={ onSubmit }>
                    { () => (
                        <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column' } }>
                            <DialogTitle>
                                <Typography variant="h6" fontWeight="bold">
                                    Usuń promocje we wskazanych punktach
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Zaznacz pody, dla których promocja na ten produkt ma zostać wycofana.
                                </Typography>
                            </DialogTitle>
                            <Divider/>

                            <DialogContent>
                                <Box sx={ { py: 1 } }>
                                    <SelectFieldMultipleFormikWithMore
                                        name="podIds"
                                        label="Wybierz punkty sprzedaży (pody)"
                                        defaultOptions={ getAllPods?.data?.filter(pod => pod?.device?.serviceId != null).map(pod => ({
                                            value: pod?.id,
                                            label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - ' + pod?.device?.serviceId
                                        })) }
                                        extraOptions={ getAllPods?.data?.filter(pod => pod?.device?.serviceId == null).map(pod => ({
                                            value: pod?.id,
                                            label: pod?.indoorPartner?.name + ' (' + pod?.description + ') - brak urządzenia'
                                        })) }
                                    />
                                </Box>
                            </DialogContent>

                            <Divider/>
                            <DialogActions sx={ { px: 3, py: 2, gap: 2 } }>
                                <Button variant="outlined" onClick={ onClose }>Anuluj</Button>
                                <SubmitButton isLoading={ deleteProductPromotions?.loading }>Usuń wybrane</SubmitButton>
                            </DialogActions>
                        </Box>
                    ) }
                </Formik>
            </Dialog>
        </>
    );
};

export default DeletePromotionsFormDialog;